<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Prescriptions",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Prescriptions",
            items: [
               {
                  text: "Prescriptions",
                  active: true,
               },                   
            ],

            prescriptions: [
               {id: 1, image: '@/assets/images/page-img/07.jpg'},
               {id: 2, image: '@/assets/images/page-img/08.jpg'},
            ],
            prescriptions_inputs: [
                  {value: null, preview_image: null, image: null}
              ],
              prescriptions_images: [],
              prescriptions_image_id: [],

              reports: [
                  {id: 1, image: '@/assets/images/page-img/07.jpg'},
                  {id: 2, image: '@/assets/images/page-img/08.jpg'},
            ],
            reports_inputs: [
                  {value: null, preview_image: null, image: null}
              ],
              reports_images: [],
              reports_image_id: [],
            
            errors: {},
         };
      },
      mounted() {
    
      },

      created(){

      },

      methods: {

         


         prescriptions_add() {
               this.prescriptions_inputs.push({ value: null });
            },

            prescriptions_remove(index) {
               this.prescriptions_inputs.splice(index, 1);
               this.prescriptions_images.splice(index, 1);
            }, 

            prescriptions_setFile(e, index) {
               this.prescriptions_images.push(e.target.files[0]);
               this.prescriptions_inputs[index].image = e.target.files[0];
            this.prescriptions_inputs[index].preview_image = URL.createObjectURL(e.target.files[0]);
         },

         prescriptions_deleteImage(id, index) {
            this.prescriptions.splice(index, 1);
            this.prescriptions_image_id.push(id);
         },


         reports_add() {
               this.reports_inputs.push({ value: null });
            },

            reports_remove(index) {
               this.reports_inputs.splice(index, 1);
               this.reports_images.splice(index, 1);
            }, 

            reports_setFile(e, index) {
               this.reports_images.push(e.target.files[0]);
               this.reports_inputs[index].image = e.target.files[0];
            this.reports_inputs[index].preview_image = URL.createObjectURL(e.target.files[0]);
         },

         reports_deleteImage(id, index) {
            this.reports.splice(index, 1);
            this.reports_image_id.push(id);
         },

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'prescriptions' }" class="btn btn-primary float-end">Back</router-link>
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-sm-6">

                        <b-card header-class="bg-transparent border-light" class="border border-light">                           

                              <h5 class="mt-1 mb-1">User : Peter John</h5>
                              <!-- <p class="mb-0">
                                 Peter John<br>
                                 +91 9110011001<br>
                                 peter@xyz.com
                              </p> -->
                        </b-card>
                           
                        </div>
                        <div class="col-sm-6">
                           <b-card header-class="bg-transparent border-light" class="border border-light p-1">                           

                              <h5 class="mt-0 mb-0">Member : Mary John</h5>
                              <!-- <p class="mb-0">
                                 Mary John<br>
                                 Female<br>
                                 11 Mar 1975
                              </p> -->
                           </b-card>
                           
                        </div>
                     </div>
                  <!----- top button area ends---->

                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <h4 class="font-size-18 border border-top-0 border-start-0 border-end-0 pb-3 mb-3">
                        Prescriptions                        
                     </h4>
                     <form>
                           
                        <b-row>
                           <b-col md="3" class="mb-3 text-center d-flex" v-for="(img) in prescriptions" :key="img.id">
                                 <div class="file-wrapper">
                                    <a href="#" target="_blank">
                                       <i class="fas fa-file-alt me-2"></i>
                                       <p>Prescription1</p>
                                    </a>
                                    <!-- <b-button variant="outline-danger" class="btn mt-2 me-1 btn-sm" @click="prescriptions_deleteImage(img.id, index)"></b-button>  -->
                                 </div>
                                                               
                                 
                              </b-col>
                           </b-row>

                     </form>
                  </b-card>

                 
                  <!-- <b-card header-class="bg-transparent border-light" class="border border-light">
                     <h4 class="font-size-18 border border-top-0 border-start-0 border-end-0 pb-3 mb-3">
                        Previous Records                      
                     </h4>
                     <form>
                        <b-row>
                           <b-col md="12">
                              <p>No prescriptions added</p>
                           </b-col>
                        </b-row>

                     </form>
                  </b-card>
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <h4 class="font-size-18 border border-top-0 border-start-0 border-end-0 pb-3 mb-3">
                        Medical Reports                        
                        <b-button v-b-modal.report-modal variant="primary" class="btn-sm float-end">Add Report</b-button>
                     </h4>

                     <form>                                
                        <b-row>
                           <b-col md="12">
                              <p>No reports added</p>
                           </b-col>
                        </b-row>

                     </form>
                  </b-card> -->

                  <!-- <b-card header-class="bg-transparent border-light" class="border border-light">
                     <h4 class="font-size-18 border border-top-0 border-start-0 border-end-0 pb-3 mb-3">
                        Prescriptions                        
                        <b-button v-b-modal.prescription-modal variant="primary" class="btn-sm float-end">Add Report</b-button>
                     </h4>

                     <form>                                 
                        <b-row>
                           <b-col md="3" class="mb-3 text-center d-flex" v-for="(img, index) in reports" :key="img.id">
                              <div class="file-wrapper">
                                 <a href="#" target="_blank">
                                    <i class="fas fa-file-alt me-2"></i> 
                                    <p>Medical Report1</p></a>
                                    
                                 <b-button variant="outline-danger" class="btn mt-2 me-1 btn-sm" @click="reports_deleteImage(img.id, index)">Delete</b-button> 
                              </div>   
                           </b-col>
                        </b-row>
                     </form>
                  </b-card> -->


                  <!---- modal starts ---->
                  <b-modal ref="prescription-modal" id="prescription-modal" title="Add Prescription" hide-footer @hidden="clearForm()">
                     <b-form>
                     

                        <b-col md="12" class="form-group">
                           <label class="control-label">Doctor Name <span class="text-danger">*</span></label>
                           <b-input-group size="sm" prepend="Dr.">
                              <input type="text" class="form-control">
                           </b-input-group>
                        </b-col>

                        <b-col md="12" class="form-group">
                           <label class="control-label">Notes <span class="text-danger">*</span></label>
                           <textarea class="form-control"></textarea>
                        </b-col>

                        <div class="form-group col-12 p-0">
                           <label class="control-label">Prescriptions <span class="text-danger">*</span></label>
                           <div class="form-control border-0">

                              <b-row v-for="(input, index) in prescriptions_inputs" :key="index" class="mb-2">    
                                 <b-col md="12" class="form-group d-flex p-0">
                                    <div class="w-90">
                                       <b-form-file class=" form-control" accept=".jpg, .png, .jpeg"  v-model="input.value" @change="prescriptions_setFile($event, index)"></b-form-file>
                                    </div>

                                    <span class="ms-1 mt-2">
                                       <i class="fas fa-minus-circle text-danger" @click="prescriptions_remove(index)" v-show="index || ( !index && prescriptions_inputs.length > 1)"></i>
                                       <i class="fas fa-plus-circle text-success" @click="prescriptions_add()" v-show="index == prescriptions_inputs.length-1"></i>
                                    </span>
                                 </b-col>
                                 
                              </b-row>

                           </div>

                           <div v-for="(val, index) in errors.prescriptions" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </div>
                       
                        
                        <b-col md="12">
                           <b-button type="submit" class="me-3" variant="primary" @click="hideModal('prescription-modal')">Save</b-button>
                           <b-button class="" variant="light" @click="hideModal('prescription-modal')">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

                  <!---- modal starts ---->
                  <b-modal ref="report-modal" id="report-modal" title="Add Report" hide-footer @hidden="clearForm()">
                     <b-form>
                        <b-col md="12" class="form-group">
                           <label class="control-label">Notes <span class="text-danger">*</span></label>
                           <textarea class="form-control"  ></textarea>

                           <!-- <div v-for="(val, index) in errors.notes" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div> -->
                        </b-col>

                        <div class="form-group col-12 p-0">
                           <label class="control-label">Reports <span class="text-danger">*</span></label>
                           <div class="form-control border-0">

                              <b-row class="mb-2">    
                                 <b-col md="12" class="form-group d-flex p-0">
                                    <div class="w-90">
                                       <b-form-file class=" form-control" accept=".jpg, .png, .jpeg"   @change="reports_setFile($event, index)"></b-form-file>
                                    </div>

                                    <span class="ms-1 mt-2">
                                       <i class="fas fa-minus-circle text-danger" @click="reports_remove(index)" v-show="index || ( !index && reports_inputs.length > 1)"></i>
                                       <i class="fas fa-plus-circle text-success" @click="reports_add()" v-show="index == reports_inputs.length-1"></i>
                                    </span>
                                 </b-col>
                                 
                              </b-row>

                           </div>

                           <!-- <div v-for="(val, index) in errors.medicalrecords" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div> -->
                        </div>
                        
                        
                        <b-col md="12">
                           <b-button type="submit" class="me-3" variant="primary" @click="hideModal('report-modal')">Save</b-button>
                           <b-button class="" variant="light" @click="hideModal('report-modal')">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

                   <!---- modal starts ---->
                  <b-modal ref="view-prescription-modal" id="view-prescription-modal" title="View Prescription" hide-footer>
                     <b-row>
                        
                        <b-col md="12" class="form-group">
                           <p class="font-size-14 mb-0">16 Nov 2022, 04:37 PM</p>
                           <h5>Dr. Nila</h5>

                           <h4 class="mt-3 font-size-15">Notes:</h4>
                           <p></p>

                           <div class="prescription-images">
                              <ul>
                                 <li  >
                                    <!-- <div class="file-img"   v-bind:style="{ 'background-image': 'url(' + '@/assets/images/prescription.jpg'+ ')' }">
                                       </div>   -->
                                       <div class="file-img"   style="background-image: url(@/assets/images/prescription.jpg)">
                                       </div>  
                                 </li>
                              </ul>
                           </div>
                        </b-col>
                        
                        <b-col md="12">
                           <b-button class="" variant="primary" @click="hideModal('view-prescription-modal')">Close</b-button>
                        </b-col>
                     </b-row>
                  </b-modal>
                  <!---- modal ends ----->


               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>

